import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FocusCerclePictoProps extends pictoProps {
}

export interface FocusCerclePictoState extends pictoState {
}

export class FocusCerclePicto extends Picto<FocusCerclePictoProps,FocusCerclePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.focusCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FocusCerclePicto);
